function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
import PropTypes from "prop-types";
import format from "date-fns/format";
//Limitless imports
import { ReadOnlyField } from "@limitless/portal";
import DateRangePickerDialog from "@limitless/portal/components/dialogs/date-range-picker-dialog/DateRangePickerDialog";
// Material imports
import makeStyles from "@mui/styles/makeStyles";
const useStyles = makeStyles({
  dateContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    border: "1px solid #e5e5e5",
    borderRadius: "8px"
  },
  readOnlyContainer: {
    border: "none",
    marginLeft: 10
  }
});
const CheckDateField = ({
  check,
  onChange,
  readOnly,
  ...rest
}) => {
  const {
    value,
    id,
    isInvalid = false
  } = check;
  const classes = useStyles();
  React.useEffect(() => {
    if (!readOnly) {
      onChange(value);
    }
  }, []);
  const dateRange = {
    startDate: value
  };
  const handleChange = dateValue => {
    onChange(dateValue);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.dateContainer
  }, /*#__PURE__*/React.createElement(ReadOnlyField, {
    label: "",
    value: value ? format(value, "DD/MM/YYYY") : "DD/MM/YYYY",
    disabled: readOnly,
    valueContainerStyles: classes.readOnlyContainer
  }), !readOnly ? /*#__PURE__*/React.createElement(DateRangePickerDialog, _extends({
    dateRange: dateRange,
    id: id,
    fullWidth: true,
    disabled: readOnly,
    onValueChange: value => handleChange(value.dateRange.startDate),
    helperText: isInvalid ? "Please select Date" : null,
    isSingleRangeSelector: true,
    minDate: new Date(1900, 1, 1),
    iconOnly: true
  }, rest)) : /*#__PURE__*/React.createElement(React.Fragment, null));
};
export default CheckDateField;
CheckDateField.propTypes = {
  check: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  readOnly: PropTypes.bool.isRequired
};